import { useQuery } from "@tanstack/react-query";

import { getAcc } from './../services/accountService';

// TODO: Use in other parts where getAcc is called
const useAccounts = () => useQuery({
    queryKey: ['accounts'],
    queryFn: () => getAcc({ accounts: [] }).then(res => res.data), // TODO: Configure accounts param
    staleTime: 60 * 60 * 1000  // 1 hour
});

export default useAccounts;